"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");
Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "BreadcrumbLink", {
  enumerable: true,
  get: function get() {
    return _BreadcrumbLink.default;
  }
});
exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
var _View = _interopRequireDefault(require("@instructure/ui-layout/lib/components/View"));
var _IconArrowOpenEnd = _interopRequireDefault(require("@instructure/ui-icons/lib/Solid/IconArrowOpenEnd"));
var _uiThemeable = _interopRequireDefault(require("@instructure/ui-themeable"));
var _ThemeablePropTypes = _interopRequireDefault(require("@instructure/ui-themeable/lib/utils/ThemeablePropTypes"));
var _uiPropTypes = require("@instructure/ui-prop-types");
var _uiTestable = _interopRequireDefault(require("@instructure/ui-testable"));
var _BreadcrumbLink = _interopRequireDefault(require("./BreadcrumbLink"));
var _theme = _interopRequireDefault(require("./theme"));
var _dec, _dec2, _class, _class2, _temp;
var styles = {
  componentId: 'fkqjh',
  template: function template(theme) {
    return "\n\n.fkqjh_bGBk{align-items:center;display:flex;font-family:".concat(theme.fontFamily || 'inherit', ";list-style-type:none;margin:0;overflow:visible;padding:0}\n\n.fkqjh_dWNq{box-sizing:border-box;position:relative}\n\n.fkqjh_dWNq:last-child{-webkit-padding-end:0;padding-inline-end:0}\n\n[dir=ltr] .fkqjh_dWNq:last-child{padding-right:0}\n\n[dir=rtl] .fkqjh_dWNq:last-child{padding-left:0}\n\n.fkqjh_fatK{box-sizing:border-box;color:").concat(theme.separatorColor || 'inherit', ";position:absolute;top:50%}\n\n.fkqjh_doqw .fkqjh_dWNq{-webkit-padding-end:calc(").concat(theme.smallSeparatorFontSize || 'inherit', "*2);-webkit-padding-start:0;font-size:").concat(theme.smallFontSize || 'inherit', ";padding-inline-end:calc(").concat(theme.smallSeparatorFontSize || 'inherit', "*2);padding-inline-start:0}\n\n[dir=ltr] .fkqjh_doqw .fkqjh_dWNq{padding-left:0;padding-right:calc(").concat(theme.smallSeparatorFontSize || 'inherit', "*2)}\n\n[dir=rtl] .fkqjh_doqw .fkqjh_dWNq{padding-left:calc(").concat(theme.smallSeparatorFontSize || 'inherit', "*2);padding-right:0}\n\n.fkqjh_doqw .fkqjh_dWNq .fkqjh_fatK{font-size:").concat(theme.smallSeparatorFontSize || 'inherit', ";inset-inline-end:calc(").concat(theme.smallSeparatorFontSize || 'inherit', "/2);inset-inline-start:auto;margin-top:calc(-1*").concat(theme.smallSeparatorFontSize || 'inherit', "/2)}\n\n[dir=ltr] .fkqjh_doqw .fkqjh_dWNq .fkqjh_fatK{left:auto;right:calc(").concat(theme.smallSeparatorFontSize || 'inherit', "/2)}\n\n[dir=rtl] .fkqjh_doqw .fkqjh_dWNq .fkqjh_fatK{left:calc(").concat(theme.smallSeparatorFontSize || 'inherit', "/2);right:auto}\n\n.fkqjh_ycrn .fkqjh_dWNq{-webkit-padding-end:calc(").concat(theme.mediumSeparatorFontSize || 'inherit', "*2);-webkit-padding-start:0;font-size:").concat(theme.mediumFontSize || 'inherit', ";padding-inline-end:calc(").concat(theme.mediumSeparatorFontSize || 'inherit', "*2);padding-inline-start:0}\n\n[dir=ltr] .fkqjh_ycrn .fkqjh_dWNq{padding-left:0;padding-right:calc(").concat(theme.mediumSeparatorFontSize || 'inherit', "*2)}\n\n[dir=rtl] .fkqjh_ycrn .fkqjh_dWNq{padding-left:calc(").concat(theme.mediumSeparatorFontSize || 'inherit', "*2);padding-right:0}\n\n.fkqjh_ycrn .fkqjh_dWNq .fkqjh_fatK{font-size:").concat(theme.mediumSeparatorFontSize || 'inherit', ";inset-inline-end:calc(").concat(theme.mediumSeparatorFontSize || 'inherit', "/2);inset-inline-start:auto;margin-top:calc(-1*").concat(theme.mediumSeparatorFontSize || 'inherit', "/2)}\n\n[dir=ltr] .fkqjh_ycrn .fkqjh_dWNq .fkqjh_fatK{left:auto;right:calc(").concat(theme.mediumSeparatorFontSize || 'inherit', "/2)}\n\n[dir=rtl] .fkqjh_ycrn .fkqjh_dWNq .fkqjh_fatK{left:calc(").concat(theme.mediumSeparatorFontSize || 'inherit', "/2);right:auto}\n\n.fkqjh_cMDj .fkqjh_dWNq{-webkit-padding-end:calc(").concat(theme.largeSeparatorFontSize || 'inherit', "*2);-webkit-padding-start:0;font-size:").concat(theme.largeFontSize || 'inherit', ";padding-inline-end:calc(").concat(theme.largeSeparatorFontSize || 'inherit', "*2);padding-inline-start:0}\n\n[dir=ltr] .fkqjh_cMDj .fkqjh_dWNq{padding-left:0;padding-right:calc(").concat(theme.largeSeparatorFontSize || 'inherit', "*2)}\n\n[dir=rtl] .fkqjh_cMDj .fkqjh_dWNq{padding-left:calc(").concat(theme.largeSeparatorFontSize || 'inherit', "*2);padding-right:0}\n\n.fkqjh_cMDj .fkqjh_dWNq .fkqjh_fatK{font-size:").concat(theme.largeSeparatorFontSize || 'inherit', ";inset-inline-end:calc(").concat(theme.largeSeparatorFontSize || 'inherit', "/2);inset-inline-start:auto;margin-top:calc(-1*").concat(theme.largeSeparatorFontSize || 'inherit', "/2)}\n\n[dir=ltr] .fkqjh_cMDj .fkqjh_dWNq .fkqjh_fatK{left:auto;right:calc(").concat(theme.largeSeparatorFontSize || 'inherit', "/2)}\n\n[dir=rtl] .fkqjh_cMDj .fkqjh_dWNq .fkqjh_fatK{left:calc(").concat(theme.largeSeparatorFontSize || 'inherit', "/2);right:auto}");
  },
  'root': 'fkqjh_bGBk',
  'crumb': 'fkqjh_dWNq',
  'separator': 'fkqjh_fatK',
  'small': 'fkqjh_doqw',
  'medium': 'fkqjh_ycrn',
  'large': 'fkqjh_cMDj'
};
var Breadcrumb = (
/**
---
category: components
---
**/
_dec = (0, _uiTestable.default)(), _dec2 = (0, _uiThemeable.default)(_theme.default, styles), _dec(_class = _dec2(_class = (_temp = _class2 = /*#__PURE__*/
function (_Component) {
  (0, _inherits2.default)(Breadcrumb, _Component);
  function Breadcrumb() {
    (0, _classCallCheck2.default)(this, Breadcrumb);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(Breadcrumb).apply(this, arguments));
  }
  (0, _createClass2.default)(Breadcrumb, [{
    key: "renderChildren",
    value: function renderChildren() {
      var numChildren = this.props.children ? this.props.children.length : 0;
      var style = {
        maxWidth: "".concat(Math.floor(100 / numChildren), "%")
      };
      return _react.default.Children.map(this.props.children, function (child, index) {
        return _react.default.createElement("li", {
          className: styles.crumb,
          style: style
        }, child, index < numChildren - 1 && _react.default.createElement(_IconArrowOpenEnd.default, {
          className: styles.separator
        }));
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _classes;
      var classes = (_classes = {}, (0, _defineProperty2.default)(_classes, styles.root, true), (0, _defineProperty2.default)(_classes, styles[this.props.size], true), _classes);
      return _react.default.createElement(_View.default, {
        role: "navigation",
        as: "div",
        margin: this.props.margin,
        "aria-label": this.props.label
      }, _react.default.createElement("ol", {
        className: (0, _classnames.default)(classes)
      }, this.renderChildren()));
    }
  }]);
  Breadcrumb.displayName = "Breadcrumb";
  return Breadcrumb;
}(_react.Component), _class2.propTypes = {
  /**
  * children of type BreadcrumbLink
  */
  children: _uiPropTypes.Children.oneOf([_BreadcrumbLink.default]),
  /**
  * An accessible label for the navigation
  */
  label: _propTypes.default.string.isRequired,
  /**
  * Sets the font-size of the breadcrumb text
  */
  size: _propTypes.default.oneOf(['small', 'medium', 'large']),
  /**
  * Valid values are `0`, `none`, `auto`, `xxx-small`, `xx-small`, `x-small`,
  * `small`, `medium`, `large`, `x-large`, `xx-large`. Apply these values via
  * familiar CSS-like shorthand. For example: `margin="small auto large"`.
  */
  margin: _ThemeablePropTypes.default.spacing
}, _class2.defaultProps = {
  size: 'medium',
  children: null,
  margin: void 0
}, _temp)) || _class) || _class);
exports.default = Breadcrumb;